import useFilterStore, {
  ProposalFilters,
  defaultValues
} from "@repo/core/stores/proposals-filters";
import { useForm } from "react-hook-form";

import { ProposalsFiltersProps } from "./types";

export const useProposalsFiltersController = ({
  onCloseFilter
}: ProposalsFiltersProps) => {
  const { filters, setFilters } = useFilterStore();
  const { control, reset, handleSubmit } = useForm<ProposalFilters>({
    defaultValues: filters
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSubmitForm = handleSubmit((data: ProposalFilters) => {
    setFilters(data);
    onCloseFilter?.();
  });

  const onResetForm = () => {
    setFilters({
      ...filters,
      type: [],
      products: [],
      servicePoint: []
    });
    reset(defaultValues);
    onCloseFilter?.();
  };

  return { control, onResetForm, onSubmitForm };
};
